import { UPLOAD_FILE } from '../../assets/icons';

function UploadFileInput({ children }: any) {
  return (
    <div className="h-20 w-full mx-2 bg-neutralBlue2 border border-dashed border-neutralBlue1 rounded-lg cursor-pointer hover:bg-neutralBlue1">
      <div className="w-full h-full flex flex-row items-center justify-start overflow-hidden">
        <img src={UPLOAD_FILE} alt="Upload ID proof" className="px-4" />
        {children}
      </div>
    </div>
  );
}

export default UploadFileInput;
